<template>
  <section>
    <div
      class="conpon-list-cell"
      v-for="(item, index) in list"
      :key="index"
      @click.prevent="goSingleCoupon(item)"
    >
      <div class="card">
        <div class="card-header">
          <a class="card-thumb">
            <div class="thumb-image">
              <img :src="item.photoUriList?item.photoUriList[0]:defaultImg" alt />
            </div>
          </a>
          <div class="card-content">
            <div class="card-title">{{item.couponMainInfo}}</div>
            <div class="card-remark">{{item.couponExtendInfo}}</div>
            <div class="card-desc">
              <!-- 核销有效期：{{item.couponEffectiveStartTime}}-{{item.couponEffectiveEndTime}}</div> -->
              核销有效期：{{item.couponEffectiveDateFmt}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    },
    memberKeyword: {
      type: String
    }
  },
  data() {
    return {
      defaultImg: require("@/image/default.png")
    };
  },
  mounted() {},
  methods: {
    goSingleCoupon(item) {
      this.$store
        .dispatch("searchMember/dispatchCouponDetail", {
          couponInstanceQrCode: item.couponInstanceQrCode,
          couponInstanceFlowWriteoffChannel: item.writeOffChannel || "商户通",
          operationType: 0
        })
        .then(({ success, error }) => {
          if (success) {
            this.$router.push({
              path: `/couponVerification/singleCoupon`,
              query: { memberKeyword: this.memberKeyword }
            });
          } else {
            this.$toast(error.msg);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.conpon-list-cell {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: px2rem(30);
  padding: px2rem(20) px2rem(40);
  border-bottom: px2rem(1) solid #bbb;
  .card {
    position: relative;
    box-sizing: border-box;
    color: #323233;
    font-size: px2rem(30);
    .card-header {
      display: flex;
      .card-thumb {
        position: relative;
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        width: px2rem(200);
        height: px2rem(200);
        margin-right: px2rem(20);
        .thumb-image {
          position: relative;
          display: inline-block;
          img {
            display: block;
            width: px2rem(200);
            height: px2rem(200);
          }
        }
      }
      .card-content {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        flex-direction: column;
        min-width: 0;
        .card-title {
          flex: 1;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          .config {
            display: inline-block;
            padding: px2rem(15);
            margin-left: px2rem(10);
            background-color: #f2f2f2;
          }
        }
        .card-desc {
          flex: 1;
          color: #7d7e80;
        }
        .card-remark {
          flex: 1;
        }
        .card-bootom {
          // line-height: 1rem;
        }
      }
    }
  }
  .coupon-info-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .coupon-info-box:nth-child(2) {
    color: #bbb;
  }
  .van-card {
    padding-left: 0;
    padding-right: 0;
    background-color: #fff;
  }
}
</style>